import { useProfilePhoto } from "../providers/profilePhotoContext";
import { responsiveImageProps } from "../utils/responsiveImages";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAppBootstrap } from "../providers/AppBootstrapProvider";

const getInitials = (value) => {
  if (!value || typeof value !== "string") {
    return "?";
  }

  const parts = value
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const first = parts[0]?.charAt(0) || "";
  const second = parts[1]?.charAt(0) || "";
  return `${first}${second}`.toUpperCase() || "?";
};

function Navigation() {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, signOut, currentUser } = useAppBootstrap();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  const profilePhotoUrl = useProfilePhoto()?.photoUrl || null;
  const profileName = currentUser?.displayName || currentUser?.email || "";

  return (
    <Navbar
      expand="lg"
      className="site-navbar"
      data-bs-theme="dark"
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/home" className="site-navbar-brand">
          <span className="site-navbar-brand-mark" aria-hidden="true">
            <img
              className="site-navbar-brand-logo"
              {...responsiveImageProps("/assets/landing/rauxa-logo.png", "34px")}
              alt=""
            />
          </span>
          RAUXA
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink className="nav-link" to="/home">
              Home
            </NavLink>
            <NavLink className="nav-link" to="/discover">
              Discover
            </NavLink>
            <NavLink className="nav-link" to="/live-racers">
              Live Racers
            </NavLink>
            {isAdmin ? (
              <NavLink className="nav-link" to="/admin">
                Admin
              </NavLink>
            ) : null}
            <NavLink className="nav-link" to="/races">
              Races
            </NavLink>
            {isAuthenticated ? (
              <NavLink className="nav-link" to="/settings">
                Settings
              </NavLink>
            ) : null}
            <NavDropdown title="Account" id="basic-nav-dropdown">
              {!isAuthenticated ? (
                <NavDropdown.Item as={NavLink} to="/login">
                  Sign In
                </NavDropdown.Item>
              ) : null}
              {isAuthenticated ? (
                <>
                  <NavDropdown.Item as={NavLink} to="/account">
                    Account
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/settings">
                    Settings
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                </>
              ) : null}
              {isAuthenticated ? (
                <NavDropdown.Item onClick={handleSignOut}>
                  Sign Out
                </NavDropdown.Item>
              ) : null}
            </NavDropdown>
            {isAuthenticated ? (
              <NavLink
                className="nav-link d-inline-flex align-items-center gap-2"
                to="/profile"
              >
                <span
                  className="site-navbar-avatar"
                  aria-hidden="true"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  {profilePhotoUrl ? (
                    <img
                      src={profilePhotoUrl}
                      alt=""
                      style={{ height: "100%", objectFit: "cover", width: "100%" }}
                    />
                  ) : (
                    getInitials(profileName)
                  )}
                </span>
                Profile
              </NavLink>
            ) : null}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
